import { GALLERY } from "../data/siteData";
import { Instagram } from "lucide-react";
import { useStore } from "../lib/store";

export const Gallery = () => {
  const { business } = useStore();
  return (
    <section id="galeria" className="section-padding bg-white" data-testid="gallery-section">
      <div className="container-aura">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <div className="text-xs tracking-luxe uppercase text-gold mb-4">Galería</div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink leading-tight mb-4">
              Momentos <span className="italic text-gold">AURA</span>
            </h2>
            <div className="gold-divider mb-6"></div>
            <p className="text-base md:text-lg text-ink-soft font-light">
              Un vistazo a nuestras instalaciones, tratamientos y la magia que vivimos cada día.
            </p>
          </div>
          <a
            href={business.social?.instagram || "#"}
            target="_blank"
            rel="noreferrer"
            data-testid="gallery-instagram"
            className="inline-flex items-center gap-2 text-sm tracking-luxe uppercase text-ink hover:text-gold transition-colors self-start md:self-end"
          >
            <Instagram size={18} />
            Síguenos en Instagram
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
          {GALLERY.map((src, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`gallery-item relative overflow-hidden rounded-2xl ${
                i === 0 || i === 5 ? "md:row-span-2 md:col-span-2 aspect-square md:aspect-auto" : "aspect-square"
              }`}
            >
              <img src={src} alt={`Galería ${i + 1}`} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-500 flex items-end p-4">
                <Instagram size={20} className="text-white" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
